export default __webpack_public_path__ + "static/trayectoria-81ff932e3501e23e731bb1bb3e070ba7.jpg";